/**
 * Date-extensions locale Azerbaijani [az]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('az', {
    monthNames: ['Yanvar','Fevral','Mart','Aprel','May','Iyun','Iyul','Avqust','Sentyabr','Oktyabr','Noyabr','Dekabr'],
    monthShortNames: ['Yan','Fev','Mar','Apr','May','Iyn','Iyl','Avq','Sen','Okt','Noy','Dek'],
    dayNames: ['Bazar','Bazar ertəsi','Çərşənbə axşamı','Çərşənbə','Cümə axşamı','Cümə','Şənbə'],
    dayShortNames: ['Baz','BzE','ÇAx','Çər','CAx','Cüm','Şən']
});
